import React, { useState } from 'react';
import './AnimalFact.css';

const AnimalFact = () => {
  const [fact, setFact] = useState(null);

  const totalFacts = [
    "A tiger's roar can be heard from up to 3 kilometers away.",
    "Elephants can communicate through the ground using vibrations.",
    "Leopards are excellent climbers and often stash their kills high in trees.",
    "Vultures have such strong stomach acid that they can safely eat diseases like anthrax and cholera.",
    "A deer’s eyes are on the sides of its head, giving them a 310-degree view.",
    "Foxes use the Earth's magnetic field as a 'ring find' to hunt their prey.",
    "No two tigers have the same stripes; they are unique like fingerprints.",
    "African elephants have larger ears shaped like the continent of Africa.",
    "Crocodiles have been around for over 200 million years—outliving the dinosaurs!",
    "Giraffes have the same number of neck bones as humans: seven.",
    "A lion's roar can be heard from Eight Kilometers away.",
    "Zebras have stripes to help keep biting flies away.",
    "Hippos cannot swim; they actually walk or run along the river bottom.",
    "Cheetahs can accelerate from 0 to 60 mph in just three seconds.",
    "Hyenas are more closely related to cats than they are to dogs.",
    "A group of flamingos is known as a 'flamboyance'.",
    "Ostriches have the largest eyes of any land animal—larger than their brains!",
    "Gorillas have unique nose prints, just like humans have unique fingerprints.",
    "Meerkats take turns acting as 'sentries' to watch for predators while others eat.",
    "A crocodile's heart rate can slow down to 2 or 3 beats per minute while diving.",
    "Honey badgers have skin so thick it can resist honeybee stings and snake bites.",
    "Wild dogs are one of the world's most successful hunters, with an 80% success rate.",
    "A giraffe's tongue is bluish-purple and can be up to 20 inches long.",
    "Warthogs often sleep in old aardvark burrows for protection.",
    "Chimpanzees share about 98.8% of their DNA with humans."
  ];


  const generateFact = () => {
    const randomFact = Math.floor(Math.random() * totalFacts.length);
    setFact(randomFact);
  };

  return (
    <div className="fact-container">
      <div className="fact-card">
        <h1>Safari Fact Finder</h1>

        <div className="fact-display">
          {fact === null ? (
            <p className="instruction">25 fascinating animal facts! Click Reveal to see the first one.</p>
          ) : (
            <div className="fact-content">
              <p className="fact-text">{totalFacts[fact]}</p>
            </div>
          )}
        </div>

        <button className="fact-btn" onClick={generateFact}>
          Reveal
        </button>
      </div>
      <footer className="project-nav">
        <p>Check out Safari Tracker App</p>
        <a
          href="https://safari-counter.vercel.app/"
          target="_blank"
          rel="noreferrer"
          className="nav-link"
        >
           Safari Sighting Tracker 
        </a>
      </footer>
    </div>
  );
};

export default AnimalFact;